module.exports = __webpack_public_path__ + "img/huaiHuaMerchants-logo.fbb9afb9.jpg";